import { ResponsiveCard } from '@framework/ui';
import * as React from 'react';
import { PageLayout } from '../../../ui/layout/PageLayout';

export interface IAlertPageLayoutProps {
  children?: React.ReactNode;
  /** removeTopHeader: se True, non viene visualizzato l'header della pagina.
   * Da utilizzare se il componente non è utilizzato in una pagina ma in una Tab.
   *
   * Default: false
   */
  noLayout?: boolean;
}

/**
 * Layout di una pagina che contiene un solo messaggio di avviso/errore.
 */
export function AlertPageLayout(props: IAlertPageLayoutProps) {
  const { noLayout, children } = props;
  if (noLayout) {
    return <>{children}</>;
  }
  return (
    <PageLayout>
      <ResponsiveCard noPadding>{children}</ResponsiveCard>
    </PageLayout>
  );
}
